import { CountryIso2 } from "react-international-phone";

// Our shops sell to a Dutch audience, so the phone field starts on NL regardless of
// the buyer's browser locale. Deriving this from navigator.language sounds smarter
// but just means a buyer on an en-GB browser gets handed +44.
export const DEFAULT_PHONE_COUNTRY: CountryIso2 = "nl";

export const PREFERRED_PHONE_COUNTRIES: CountryIso2[] = ["nl", "be", "de", "gb", "fr"];
